module.exports = __webpack_public_path__ + "static/media/Jordanne Rast Headshot.283a32c5.png";